module.exports = __webpack_public_path__ + "img/new-angle-right.2fb61d06.svg";